import { SpectatorRoomSession } from '../data/session/spectator_room_session';
import { HostRoomSession } from '../data/session/host_room_session';
import { RoomSession } from '../data/session/room_session';
import { OnSiteRoomSession } from '../data/session/onsite_room_session';
import { VideoController } from '../data/controllers/video_controller/video_controllers';
export function isSpectatorRoomSession(session) {
    return session instanceof SpectatorRoomSession;
}
export function isHostRoomSession(session) {
    return session instanceof HostRoomSession;
}
export function isOnSiteRoomSession(session) {
    return session instanceof OnSiteRoomSession;
}
export function isVideoController(controller) {
    return controller instanceof VideoController;
}
export function isRoomSession(session) {
    return session instanceof RoomSession;
}
//# sourceMappingURL=guards.js.map